module.exports = __webpack_public_path__ + "static/home_pic.d6c4aa65.png";